"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports.MessageBannerText = exports.MessageBannerRow = exports.MessageBannerIconWrapper = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../link/constants");

var _button = require("../button");

var _context = require("../context");

var _layout = require("../layout");

var _text = require("../text");

var _utils = require("../utils");

var _constants2 = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MessageBannerRow = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var colorBase = _ref.colorBase,
      isMouseFocus = _ref.isMouseFocus,
      selectors = _ref.theme.selectors;
  var backgroundColor = selectors.color("".concat(colorBase, "10"));
  var borderColor = selectors.color("".concat(colorBase, "50"));
  var borderRadius = selectors.radius('R300');
  var lineHeight = selectors.lineHeight(_constants2.FONT_SIZE);
  var fontSize = selectors.fontSize(_constants2.FONT_SIZE);
  var verticalPadding = Math.round(_constants2.BANNER_MIN_HEIGHT - (0, _utils.getContentHeight)(lineHeight, fontSize)) / 2;
  return {
    alignItems: 'flex-start',
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    borderLeft: "".concat((0, _utils.px)(_constants2.BANNER_BAR_WIDTH), " solid ").concat(borderColor),
    gap: (0, _utils.px)(selectors.space('S200')),
    padding: "".concat((0, _utils.px)(verticalPadding), " ").concat((0, _utils.px)(_constants2.BANNER_PADDING)),
    ':focus': {
      outline: isMouseFocus ? 'none' : "".concat((0, _utils.px)(_constants2.BANNER_BORDER_WIDTH), " solid ").concat(borderColor),
      outlineOffset: (0, _utils.px)(_constants2.BANNER_BORDER_WIDTH)
    }
  };
});
exports.MessageBannerRow = MessageBannerRow;
var MessageBannerIconWrapper = (0, _context.styledWithTheme)(_layout.View)(function (_ref2) {
  var colorBase = _ref2.colorBase,
      selectors = _ref2.theme.selectors;
  var lineHeight = selectors.lineHeight(_constants2.FONT_SIZE);
  var fontSize = selectors.fontSize(_constants2.FONT_SIZE);
  var height = (0, _utils.getContentHeight)(lineHeight, fontSize);
  return _objectSpread({
    alignItems: 'center',
    display: 'flex',
    height: height
  }, colorBase ? {
    color: selectors.color(_constants2.MessageBannerIconColors[colorBase])
  } : {});
});
exports.MessageBannerIconWrapper = MessageBannerIconWrapper;
var MessageBannerText = (0, _context.styledWithTheme)(_text.Text)(function (_ref3) {
  var selectors = _ref3.theme.selectors;
  return {
    '& a': {
      borderRadius: selectors.radius(_constants.INLINE_BORDER_RADIUS),
      color: selectors.color(_constants2.TEXT_COLOR),
      textDecoration: 'underline',
      fontWeight: selectors.fontWeight('medium')
    },
    '& a:visited': {
      color: selectors.color(_constants2.TEXT_COLOR)
    },
    '& a:hover': {
      textDecoration: 'none'
    },
    '& a:focus': {
      outline: "2px solid ".concat(selectors.color(_constants2.TEXT_COLOR)),
      outlineOffset: '2px'
    },
    '& a:active': {
      color: (0, _utils.darken)(selectors.color(_constants2.TEXT_COLOR), 0.05)
    }
  };
});
exports.MessageBannerText = MessageBannerText;
MessageBannerText.defaultProps = _objectSpread(_objectSpread({}, _text.Text.defaultProps), {}, {
  color: _constants2.TEXT_COLOR,
  display: 'inline',
  fontSize: _constants2.FONT_SIZE
});
var StyledButton = (0, _context.styledWithTheme)(_button.Button)(function (_ref4) {
  var colorBase = _ref4.colorBase,
      selectors = _ref4.theme.selectors;
  return {
    ':hover,:focus,:active': {
      borderColor: selectors.color("".concat(colorBase, "70")),
      outlineColor: selectors.color("".concat(colorBase, "70"))
    }
  };
});
exports.StyledButton = StyledButton;